document.addEventListener("DOMContentLoaded", function () {
  console.log("Bundler.js loaded: DOMContentLoaded fired.");

  const searchInput = document.getElementById("bundle-search");
  const productContainer = document.getElementById("bundle-products");
  const summarySubtotal = document.getElementById("bundle-subtotal");
  const summarySavings = document.getElementById("bundle-savings");
  const checkoutBtn = document.getElementById("bundle-checkout");

  if (!productContainer) {
    console.error("Error: #bundle-products container not found in the DOM.");
    return;
  }

  let bundle = {};
  let allProducts = [];
  const DISPLAY_LIMIT = 20; // Limit displayed products to 20

  // Format currency
  function formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  // Calculate discount rate based on number of items
  function calculateDiscount(numItems) {
    return Math.min(numItems * 0.05, 0.25);
  }

  // Update the summary section
  function updateSummary() {
    const items = Object.values(bundle);
    const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
    const fullTotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discountRate = calculateDiscount(totalQty);
    const discountedTotal = fullTotal * (1 - discountRate);
    const savings = fullTotal - discountedTotal;

    summarySubtotal.textContent = formatMoney(discountedTotal);
    if (savings > 0) {
      summarySavings.textContent = `You saved ${formatMoney(savings)} (${(discountRate * 100).toFixed(0)}% off ${totalQty} items)`;
      summarySavings.style.display = "block";
    } else {
      summarySavings.style.display = "none";
    }
  }

  // Update the bundle data when product quantity changes
  function updateBundle(productId, quantity) {
    const product = allProducts.find(p => p.id == productId);
    if (!product) {
      console.warn("Product not found for id:", productId);
      return;
    }
    if (quantity > 0) {
      bundle[productId] = { ...product, quantity };
    } else {
      delete bundle[productId];
    }
    updateSummary();
  }

  // Render a limited number of products into the container
  function renderProducts(products) {
    if (!productContainer) {
      console.error("renderProducts: productContainer element not found.");
      return;
    }
    console.log("Rendering products:", products.length, "items");
    // Limit displayed products
    const productsToShow = products.slice(0, DISPLAY_LIMIT);
    productContainer.innerHTML = "";
    productsToShow.forEach(product => {
      const card = document.createElement("div");
      card.className = "bundle-product-card";
      card.innerHTML = `
        <img src="${product.image}" alt="${product.title}">
        <h3>${product.title}</h3>
        <p class="bundle-price">$${product.price.toFixed(2)}</p>
        <div class="bundle-quantity" data-product-id="${product.id}">
          <button class="minus">−</button>
          <input type="number" min="0" value="0" />
          <button class="plus">+</button>
          <span class="added-message"></span>
        </div>
      `;
      productContainer.appendChild(card);

      // Attach quantity control listeners
      const input = card.querySelector("input");
      const plus = card.querySelector(".plus");
      const minus = card.querySelector(".minus");
      const message = card.querySelector(".added-message");

      function updateQuantity(newQty) {
        input.value = newQty;
        if (newQty > 0) {
          message.textContent = "🎉 Nice pick! Added.";
          message.style.color = "green";
          setTimeout(() => { message.textContent = ""; }, 2000);
        } else {
          message.textContent = "";
        }
        updateBundle(product.id, newQty);
      }

      plus.addEventListener("click", () => updateQuantity(Number(input.value) + 1));
      minus.addEventListener("click", () => {
        if (Number(input.value) > 0) updateQuantity(Number(input.value) - 1);
      });
      input.addEventListener("change", () => updateQuantity(Number(input.value)));
    });
  }

  // Filter allProducts based on the search term and render results
  function handleSearch(term) {
    const lowerTerm = term.toLowerCase().trim();
    console.log("Searching for:", lowerTerm);
    const filtered = allProducts.filter(p => p.title.toLowerCase().includes(lowerTerm));
    renderProducts(filtered);
  }

  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      console.log("Search input changed:", e.target.value);
      handleSearch(e.target.value);
    });
  } else {
    console.error("Search input (#bundle-search) not found.");
  }

  // Load products from hidden JSON blocks
  document.querySelectorAll(".bundle-product-data").forEach(el => {
    try {
      const product = JSON.parse(el.textContent);
      if (!product.id) product.id = product.handle || product.title;
      allProducts.push(product);
    } catch (e) {
      console.error("Error parsing product data", e);
    }
  });

  // Fallback: if no hidden JSON is found, build products from visible cards
  if (allProducts.length === 0) {
    document.querySelectorAll(".bundle-product-card").forEach(card => {
      const titleEl = card.querySelector("h3");
      const priceEl = card.querySelector(".bundle-price");
      const quantityEl = card.querySelector(".bundle-quantity");
      if (titleEl && priceEl && quantityEl) {
        const product = {
          title: titleEl.textContent.trim(),
          price: parseFloat(priceEl.textContent.replace("$", "")),
          id: quantityEl.dataset.productId || titleEl.textContent.trim(),
          image: card.querySelector("img") ? card.querySelector("img").src : ""
        };
        allProducts.push(product);
      }
    });
  }

  console.log("All products loaded:", allProducts.length);

  // Initially render the first DISPLAY_LIMIT products
  renderProducts(allProducts);
  updateSummary();

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", () => {
      if (Object.keys(bundle).length === 0) {
        alert("Please add at least one item to your bundle.");
        return;
      }
      const items = Object.values(bundle).flatMap(item => [{
        id: item.variantId || item.id,
        quantity: item.quantity
      }]);
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/cart";

      items.forEach(item => {
        const inputId = document.createElement("input");
        inputId.type = "hidden";
        inputId.name = `updates[${item.id}]`;
        inputId.value = item.quantity;
        form.appendChild(inputId);
      });

      document.body.appendChild(form);
      form.submit();
    });
  }
});